import { PlayCircleOutlined } from '@ant-design/icons'
import { AppSession } from '@prisma/client'
import { Alert, Button, Flex } from 'antd'
import React from 'react'
import { useAppSession } from '~/features/appSession/client/hooks/useAppSession'

type Props = {
  appSession: AppSession
  agentName: string
}

export const RenderAgentDisabled: React.FC<Props> = ({
  agentName = 'Agent',
  appSession,
}) => {
  const { setStatus } = useAppSession({ appSession })

  return (
    <Flex vertical className="w-full" style={{ padding: '8px 16px' }}>
      <Alert
        icon={<Flex className="pt-3">✈️</Flex>}
        showIcon
        // style={{ minWidth: '250px' }}
        message={`${agentName}  is taking a short break`}
        description={`All of ${agentName}’s tasks, workflows, and automations are on standby. When you’re ready, call them back to work.`}
        type="warning"
        action={
          <Button
            type="default"
            size="large"
            // shape="round"
            icon={<PlayCircleOutlined />}
            onClick={() => setStatus('ACTIVE')}
          >
            Resume Agent
          </Button>
        }
      />
    </Flex>
  )
}
